import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Tooltip } from '@mui/material';
import { normalizeTimeField } from '#component/form/time-fields/helper';
import { StyledInfoIcon } from '#component/form/time-fields/style';
import RHFTextField from './rhf-text-field';

/**
 * Renders 3 time field inputs for React Hook Form.
 * In format day/hour/minutes
 * @returns {React.FC}
 */

const RHFTimeFields = ({
  name,
  label,
  disabled,
  hint,
  Container = 'div',
  TimeDeviationCnt = 'div',
  DeviationFieldTitle = 'span',
  TextError = 'span',
  error: errorMessage
}) => {
  const { getFieldState } = useFormContext() || {};
  const { error: fieldError } = (getFieldState && getFieldState(name)) || {};
  const error = errorMessage ?? fieldError?.message;

  return (
    <Container>
      <TimeDeviationCnt>
        <DeviationFieldTitle hasError={!!error} hasHint={!!hint}>
          {hint &&
            <Tooltip title={hint.tooltip}>
              <StyledInfoIcon />
            </Tooltip>}
          {label}
        </DeviationFieldTitle>
        <RHFTextField
          name={`${name}.day`}
          label="Day"
          variant="outlined"
          normalize={normalizeTimeField}
          error={!!error}
          disabled={disabled}
        />
        <RHFTextField
          name={`${name}.hour`}
          label="Hour"
          variant="outlined"
          normalize={normalizeTimeField}
          error={!!error}
          disabled={disabled}
        />
        <RHFTextField
          name={`${name}.minute`}
          label="Min"
          variant="outlined"
          normalize={normalizeTimeField}
          error={!!error}
          disabled={disabled}
        />
      </TimeDeviationCnt>
      {error && <TextError>{error}</TextError>}
    </Container>
  );
};

export default RHFTimeFields;
